import Vue from 'vue';
import Vuex from 'vuex';
import models from '@/store/models';
import uis from '@/store/uis';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    ...models,
    ...uis,
  },
  getters: {
    baseUrl() {
      return INDEEGO_BASE_URL; // eslint-disable-line
    },
  },
});
